import { consts } from '@allesauto/utils/consts';
import { fromUrlJSON, isEmptyObject } from '@allesauto/utils/funcs';
import { NextRouter } from 'next/router';

import { IParsedQuery } from '../types';

export const getParsedUrlQuery = (urlQuery: NextRouter['query']) => {
  const {
    bodyColors,
    priceRange,
    drive,
    makeModel,
    location,
    merchantLocation,
    sorting,
    itemsPerPage,
    filterAccordionStates,
    interior,
    fuelType,
    vehicleType,
    vehicleCondition,
    equipment,
    page,
    emission,
  } = urlQuery;

  const parsedQuery: IParsedQuery = {};

  if (!isEmptyObject(filterAccordionStates))
    parsedQuery.filterAccordionStates = fromUrlJSON(
      filterAccordionStates as any
    );

  if (!isEmptyObject(interior)) {
    parsedQuery.interior = fromUrlJSON(interior as any);
  }

  if (!isEmptyObject(vehicleType)) {
    parsedQuery.vehicleType = fromUrlJSON(vehicleType as any);
  }
  if (!isEmptyObject(equipment)) {
    parsedQuery.equipment = fromUrlJSON(equipment as any);
  }

  if (!isEmptyObject(bodyColors))
    parsedQuery.bodyColors = fromUrlJSON(bodyColors as any);

  if (!isEmptyObject(location))
    parsedQuery.location = { ...fromUrlJSON(location as any) };

  if (!isEmptyObject(merchantLocation)) {
    parsedQuery.merchantLocation = fromUrlJSON(merchantLocation as any);
  }

  if (
    !isEmptyObject(itemsPerPage) &&
    consts.PCP.HORIZONTAL_TOOLBAR.RESULTS_PER_PAGE.includes(
      parseInt(itemsPerPage as any, 10)
    )
  )
    parsedQuery.itemsPerPage = parseInt(itemsPerPage as any, 10);

  if (!isEmptyObject(sorting)) {
    parsedQuery.sorting = fromUrlJSON(sorting as any);
  }

  if (!isEmptyObject(priceRange))
    parsedQuery.priceRange = fromUrlJSON(priceRange as any);

  if (!isEmptyObject(makeModel))
    parsedQuery.makeModel = fromUrlJSON(makeModel as string);

  if (!isEmptyObject(drive)) {
    parsedQuery.drive = fromUrlJSON(drive as any);
  }

  if (!isEmptyObject(fuelType)) {
    parsedQuery.fuelType = fromUrlJSON(fuelType as any);
  }

  if (!isEmptyObject(emission)) {
    parsedQuery.emission = fromUrlJSON(emission as any);
  }

  if (!isEmptyObject(vehicleCondition)) {
    parsedQuery.vehicleCondition = fromUrlJSON(vehicleCondition as any);
  }

  if (!isEmptyObject(page)) {
    parsedQuery.page = fromUrlJSON(page as any);
  }

  return parsedQuery;
};
